import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Svg from "./Svg";
import { UPDATE_AVAILABLE_EVENT, getWaitingWorker, applyUpdate } from "../../helpers/ServiceWorkerUpdates";

/**
 * UpdateNotice
 * Lets the user know a new version of the app has downloaded, and switches to it when they
 * choose (ServiceWorkerUpdates.js). Kept off the caller screen, which is often projected for the
 * room - the update also applies on its own once every tab of the site is closed.
 */
export default function UpdateNotice() {
  const location = useLocation();
  const [updateReady, setUpdateReady] = useState(() => getWaitingWorker() !== null);
  const [dismissed, setDismissed] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    const handleUpdateAvailable = () => setUpdateReady(true);
    document.addEventListener(UPDATE_AVAILABLE_EVENT, handleUpdateAvailable);
    return () => document.removeEventListener(UPDATE_AVAILABLE_EVENT, handleUpdateAvailable);
  }, []);

  const handleUpdate = () => {
    setUpdating(true);
    applyUpdate();
  };

  if (!updateReady || dismissed || location.pathname === "/") {
    return null;
  }

  return (
    <div className="update-notice no-print" role="status">
      <Svg icon="sparkles" size="md" decorative />
      <p>
        <strong>A new version is ready.</strong> Update now to get the latest fixes and features. It only takes a moment.
      </p>
      <div className="update-notice__actions">
        <button type="button" className="secondary-button small-button" onClick={() => setDismissed(true)} disabled={updating}>
          Later
        </button>
        <button type="button" className="primary-button small-button" onClick={handleUpdate} disabled={updating}>
          {updating ? "Updating…" : "Update Now"}
        </button>
      </div>
    </div>
  );
}
